export const CREATE_VIDEO_TOUR = "CREATE_VIDEO_TOUR";
export const UPDATE_VIDEO_TOUR = "UPDATE_VIDEO_TOUR";
export const GET_ALL_VIDEO_TOURS = "GET_ALL_VIDEO_TOURS";
export const DELETE_VIDEO_TOUR = "DELETE_VIDEO_TOUR";
